import API_MAP from "../../constants/api";
import axiosClient from "../axiosClient";

class ApiMcu {
    getListRooms = (roomNameOrRoomCode = "", page = 0, size = 10) => {
        return axiosClient.get(API_MAP.MCU.GET_LIST_ROOM + "?page=" + page + "&size=" + size + (roomNameOrRoomCode ? `&roomNumberOrName=${roomNameOrRoomCode}` : '') + '&enabled=true');
    }
    createRoom = (roomNumber, roomName) => {
        return axiosClient.post(API_MAP.MCU.CREATE_ROOM, { room_number: roomNumber, room_name: roomName })
    }
    getSimpleLayouts = () => {
        return axiosClient.get(API_MAP.MCU.LAYOUTS + "/simple")
    }
    getSimpleLayoutGroups = () => {
        return axiosClient.get(API_MAP.MCU.LAYOUTS + "/groups/simple")
    }
    getRoomAndLayoutInfo = (roomId) => {
        return axiosClient.get(API_MAP.MCU.ROOMS + "/" + roomId)
    }
    getLayoutDetail = (layout) => {
        return axiosClient.get(API_MAP.MCU.LAYOUTS + "/" + layout)
    }
    setRoomLayout = (roomId, layout) => {
        return axiosClient.post(API_MAP.MCU.ROOMS + "/" + roomId + "/layout", {
            layout_name: layout
        })
    }
    getRoomMembers = (roomId) => {
        return axiosClient.get(API_MAP.MCU.ROOMS + "/" + roomId + "/members")
    }
    pinMember = (roomId, fsid, reservationId) => {
        return axiosClient.post(API_MAP.MCU.ROOMS + "/" + roomId + "/members/" + fsid + "/pin", {
            reservation_id: reservationId
        })
    }
    updateRoom = (id, code, name) => {
        return axiosClient.post(API_MAP.MCU.UDPATE_ROOM + '/' + id, { room_number: code, room_name: name });
    }
    deleteRoom = (id) => {
        return axiosClient.post(API_MAP.MCU.DELETE_ROOM + '/' + id);
    }

    //mcu-monitor
    getListMonitorRooms = (currentPage, roomNameOrRoomCode = "") => {
        return axiosClient.get(API_MAP.MCU.MONITOR.GET_LIST_ROOM + `?page=${currentPage}` + (roomNameOrRoomCode ? `&keyword=${roomNameOrRoomCode}` : ''));
    }

    getRoomInfo = (nodeId, room) => {
        return axiosClient.get(API_MAP.MCU.MONITOR.GET_ROOM_INFO + `/${room}/members/list`)
    }

    //mcu-settings
    getListSipAccount = (currentPage, username) => {
        return axiosClient.get(API_MAP.MCU.SIP.GET_LIST_ACCOUNT + `?page=${currentPage}` + (username ? `&username=${username}` : ''));
    }
    updateSipAccount = (body, id) => {
        return axiosClient.post(API_MAP.MCU.SIP.UPDATE_ACCOUNT + `/${id}`, body);
    }
    createSipAccount = (body) => {
        return axiosClient.post(API_MAP.MCU.SIP.CREATE_ACCOUNT, body);
    }
    deleteSipAccount = (id) => {
        return axiosClient.post(API_MAP.MCU.SIP.DELETE_ACCOUNT + `/${id}`)
    }
    getListDevices = ({page, size = "5", codeOrName}) => {
        return axiosClient.get(API_MAP.MCU.DEVICES.GET_LIST + `?page=${page}&size=${size}` + (codeOrName ? `&code_or_name=${codeOrName}` : ''))
    }
    deleteDevice = (id) => {
        return axiosClient.post(API_MAP.MCU.DEVICES.DELETE_DEVICE + `/${id}`);
    }
    createDevice = (body) => {
        return axiosClient.post(API_MAP.MCU.DEVICES.CREATE_DEVICE, body);
    }
    updateDevice = (body, id) => {
        return axiosClient.post(API_MAP.MCU.DEVICES.UPDATE_DEVICE + `/${id}`, body);
    }
}

const apiMcu = new ApiMcu();

export default apiMcu;